import { ValidationProvider } from "vee-validate/dist/vee-validate.full";

export default {
  name: "binput",
  components: {
    ValidationProvider,
  },
  props: [
    "name",
    "label",
    "type",
    "validation",
    "value",
    "icon",
    "placeholder",
    "focus",
    "loading",
    "noGlow",
    "css",
    "disabled",
    "mode",
    "hideError",
  ],
  data() {
    return {
      confirmVal: "",
      confirm: false,
      vid: "",
      timerId: null,
      valid: false,
    };
  },
  created() {
    if (typeof this.validation === "string") {
      if (this.validation && this.validation.includes("confirmed")) {
        let rulesArr = this.validation.split("|");
        let found = rulesArr.find((x) => x.includes("confirmed"));
        this.$set(this, "vid", found.split(":")[1]);
        this.$set(this, "confirm", true);
      } else {
        this.$set(this, "confirm", false);
      }
    }
  },
  mounted() {
    if (this.focus) {
      this.$nextTick(() => {
        let el = this.$refs[this.name];
        if (el) el.focus();
      });
    }
  },
  watch: {
    value: function(newVal, oldVal) {
      if (this.confirm && !newVal) {
        this.confirmVal = "";
      }
    },
  },
  methods: {
    async UpdateValue(event) {
      if (event) {
        this.$emit("input", event.target.value);

        if (this.timerId) clearTimeout(this.timerId);
        this.timerId = setTimeout(() => {
          this.timerId = null;
          if (this.$refs.observer) {
            this.valid = this.$refs.observer.errors.length === 0;
            this.$emit("valid", this.valid);
          }
        }, 150);
      } else this.$emit("input", this.value);
    },
  },
};
